import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Manager, Target, Popper } from 'react-popper';

import './index.less';

class Icon extends React.Component {
	constructor(props) {
		super(props);

		// Using https://feathericons.com/
		// Download one you want, poke it open, make a compound path, put their content in this array
		this.icons = {
			RightArrow: 'M5,12h14 M12,5l7,7l-7,7',
			RightChevron: 'M9,18l6-6L9,6',
			AlertCircle:
				'M12,2c5.5,0,10,4.5,10,10s-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2z M12,8v4 M12,16L12,16',
			CircleCheckmark:
				'M22,11.1V12c0,5.5-4.5,10-10,10C6.5,22,2,17.5,2,12C2,6.5,6.5,2,12,2c1.4,0,2.8,0.3,4.1,0.9 M22,4L12,14l-3-3',
			TrashBin:
				'M3,6h2h16 M19,6v14c0,1.1-0.9,2-2,2H7c-1.1,0-2-0.9-2-2V6 M8,6V4c0-1.1,0.9-2,2-2h4c1.1,0,2,0.9,2,2v2 M10,11v6M14,11v6',
			Award:
				'M12,1c3.9,0,7,3.1,7,7s-3.1,7-7,7s-7-3.1-7-7S8.1,1,12,1z M8.2,13.9L7,23l5-3l5,3l-1.2-9.1',
			Edit:
				'M20,14.7V20c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h5.3 M18,2l4,4L12,16H8v-4L18,2z',
			Lock:
				'M5,11h14c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2v-7C3,11.9,3.9,11,5,11z M7,11V7c0-2.8,2.2-5,5-5s5,2.2,5,5v4',
			Power: 'M18.4,6.6c3.5,3.5,3.5,9.2,0,12.7s-9.2,3.5-12.7,0c-3.5-3.5-3.5-9.2,0-12.7 M12,2v10',
			Mail:
				'M4,4h16c1.1,0,2,0.9,2,2v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6C2,4.9,2.9,4,4,4z M22,6l-10,7L2,6',
			UserAdd:
				'M16,21v-2c0-2.2-1.8-4-4-4H5c-2.2,0-4,1.8-4,4v2 M8.5,3c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S6.3,3,8.5,3zM20,8v6 M23,11h-6'
		};

		this.state = {
			isHovered: false
		};

		const portalNode = document.createElement('div');
		portalNode.className = 'Icon__portal';
		document.body.appendChild(portalNode);
	}

	render() {
		const { color, icon, size, tooltip } = this.props;
		const { isHovered } = this.state;

		const iconElement = (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox={`0 0 24 24`}
				fill="none"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				height={`${size}px`}
			>
				<path d={this.icons[icon] || this.icons['AlertCircle']} />
			</svg>
		);

		const tooltipPortal = ReactDOM.createPortal(
			<Popper>
				<div className={`Icon__tooltip ${isHovered ? 'Icon__tooltip--show' : ''}`}>{tooltip}</div>
			</Popper>,
			//Change to app with react
			document.querySelector('.Icon__portal')
		);

		return (
			<div
				className="Icon"
				onMouseOver={() => this.setState({ isHovered: true })}
				onMouseLeave={() => this.setState({ isHovered: false })}
				aria-label={icon}
			>
				{!tooltip ? (
					iconElement
				) : (
					<Manager>
						<React.Fragment>
							<Target>{iconElement}</Target>
							{tooltipPortal}
						</React.Fragment>
					</Manager>
				)}
			</div>
		);
	}
}

Icon.defaultProps = {
	color: '#2d272d',
	size: '20'
};

Icon.propTypes = {
	icon: PropTypes.string.isRequired,
	color: PropTypes.string,
	size: PropTypes.string,
	tooltip: PropTypes.string
};

export default Icon;
